import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { navigationSlice, NavigationUtils, useAppDispatch } from '@ax/redux-store';
import { NavigationPages } from '@ax/constants';

const RouteChangeHandler = () => {
  const [previousPage, setPreviousPage] = useState<NavigationPages | null>(null);
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const currentPage = NavigationUtils.toNavigationPage(location.pathname);

    if (previousPage !== currentPage) {
      setPreviousPage(currentPage);
    }

    dispatch(
      navigationSlice.actions.pageNavigationSucceeded({
        page: currentPage,
        previous: previousPage,
      }),
    );
  }, [location, dispatch]);

  return null; // This component doesn't render anything.
};

export default RouteChangeHandler;
